import { Measurement } from "../models/measurement";
import { RoomJob } from "../models/sales";
import { handleGetConvertValue } from "./converts";
import { DESTINATION } from "./enums";

export interface TotalItemValues {
  volume: number;
  volumeConverted: number;
  weight: number;
  quantity: number;
  volumeFormatted?: string;
  weightFormatted?: string;
}

export const getTotalItemsValuesByInventory = (
  inventory?: RoomJob[],
  measurement?: Measurement
): TotalItemValues => {
  let totalVolume = 0;
  let totalQuantity = 0;
  let totalWeight = 0;

  inventory?.forEach((inv) => {
    inv?.itemsJob?.forEach((itemJob) => {
      if (itemJob?.itemJob?.destination?.name !== DESTINATION.NOT_GOING) {
        totalVolume +=
          Number(itemJob?.itemJob?.volume || 0) * Number(itemJob?.itemJob?.quantity || 0);
        totalQuantity += Number(itemJob?.itemJob?.quantity || 0);
        totalWeight += Number(itemJob?.itemJob?.weight || 0);
      }
    });
    inv?.materials?.forEach((material) => {
      if (
        material?.serviceBooking &&
        material?.serviceBooking?.isItem &&
        material?.destination?.name !== DESTINATION.NOT_GOING
      ) {
        totalVolume += Number(material?.volume || 0) * Number(material?.quantity || 0);
        totalQuantity += Number(material?.quantity || 0);
        totalWeight += Number(material?.weight || 0);
      }
    });
  });
  const volumeFormatted = handleGetConvertValue(
    totalVolume,
    measurement?.code,
    measurement?.decimalPlaces
  );

  return {
    volume: totalVolume,
    volumeConverted: Number(volumeFormatted),
    quantity: totalQuantity,
    weight: totalWeight,
    volumeFormatted: String(volumeFormatted ?? 0),
    weightFormatted: totalWeight.toString(),
  };
};
